<script setup lang="ts">
withDefaults(defineProps<{
  title: string;
  hint?: string;
  open?: boolean;
}>(), {
  hint: '',
  open: false,
});
</script>

<template>
  <details class="vptw:group vptw:border-b vptw:border-(--vs-line) vptw:last:border-b-0" :open="open">
    <summary class="vptw:flex vptw:min-w-0 vptw:cursor-pointer vptw:list-none vptw:items-center vptw:justify-between vptw:gap-3 vptw:px-3 vptw:py-3 vptw:outline-none vptw:transition-colors vptw:hover:bg-(--vs-surface-2) vptw:focus-visible:ring-2 vptw:focus-visible:ring-inset vptw:focus-visible:ring-(--vs-accent)">
      <span class="vptw:min-w-0">
        <span class="vptw:block vptw:text-xs vptw:font-semibold vptw:text-(--vs-ink)">{{ title }}</span>
        <span v-if="hint" class="vptw:mt-0.5 vptw:block vptw:truncate vptw:text-[10px] vptw:text-(--vs-ink-3)">{{ hint }}</span>
      </span>
      <svg class="vptw:size-4 vptw:shrink-0 vptw:text-(--vs-ink-3) vptw:transition-transform group-open:vptw:rotate-180" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.168l3.71-3.938a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06Z" clip-rule="evenodd" /></svg>
    </summary>
    <div class="vptw:min-w-0 vptw:px-3 vptw:pb-4">
      <slot />
    </div>
  </details>
</template>
